import { axios } from '@/utils/request'

export function sendSubscription (parameter) {
    return axios({
        url: '/subscription/',
        method: 'post',
        params: parameter
    })
}
